import React, { useEffect, useRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useLocation, Routes, Route, Navigate, useNavigate } from 'react-router-dom';

// 기본 레이아웃과 인증 관련 컴포넌트는 즉시 로드
import Layout from '../features/layout/Layout';
import AuthRoute from './AuthRoute';
import Gate from './Gate';
import Loading from '../components/common/Loading';

// 나머지 컴포넌트들은 lazy 로드
import Main from '../features/main';
import Login from '../features/login';
import BirthLogin from '../features/login/birth';
import SSOLogin from '../features/login/sso';
import BirthVerification from '../features/smsVerification';
import AuthComplete from '../features/verificationSuccess';
import MyInfo from '../features/myInfo';
import PreviousEmployment from '../features/previousEmployment';
// import PreviousEmploymentDetail from '../features/previousEmployment/detail/PreviousEmploymentDetail';
import Dependents from '../features/dependents';
import ItemSelection from '../features/deductions/itemSelection';
import InsurancePremiums from '../features/deductions/insurancePremiums';
// import InsuranceDetail from '../features/deductions/insurancePremiums/detail';
import MedicalExpenses from '../features/deductions/medicalExpenses';
// import MedicalDetail from '../features/deductions/medicalExpenses/detail';
import EducationExpenses from '../features/deductions/educationExpenses';
// import EducationDetail from '../features/deductions/educationExpenses/detail';
import Donations from '../features/deductions/donations';
import DonationsDetail from '../features/deductions/donations/detail';
import CreditCards from '../features/deductions/creditCards';
import HousingFunds from '../features/deductions/housingFunds';
import OtherDeductions from '../features/deductions/otherDeductions';
import EvidenceDocuments from '../features/evidenceDocuments';
import ResultQuery from '../features/resultQuery';
import EDocuments from '../features/eDocuments';
import FindPassword from '../features/findPassword';
import Twc from '../components/Twc';
import Terms from '../features/terms';
import AiAssistantDialog from '../features/aiAssistant/AiAssistantDialog';
import TaxChangeAlert from '../features/main/TaxChangeAlert';

const MainRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const nodeRef = useRef(null);

  useEffect(() => {
    if (navigate.type === 'POP') return;
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return (
    <div>
      <SwitchTransition>
        <CSSTransition key={location.pathname} classNames="fade" timeout={300} nodeRef={nodeRef}>
          <div className="bodyContainer" ref={nodeRef}>
            <Routes location={location}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Layout />
                  </AuthRoute>
                }>
                {/* 메인 */}
                <Route index element={<Main />} />
                {/* 내정보 */}
                <Route path="/myInfo" element={<MyInfo />} />
                {/* 전직장 */}
                <Route path="/previousEmployment" element={<PreviousEmployment />} />
                {/* <Route path="/previousEmployment/detail" element={<PreviousEmploymentDetail />} /> */}
                {/* 부양가족 */}
                <Route path="/dependents" element={<Dependents />} />
                {/* 전자문서 */}
                <Route path="/eDocuments" element={<EDocuments />} />
                {/* 공제 -항목선택*/}
                <Route path="/deductions/itemSelection" element={<ItemSelection />} />
                {/* 공제 -보험료*/}
                <Route path="/deductions/insurancePremiums" element={<InsurancePremiums />} />
                {/* <Route path="/deductions/insurancePremiums/detail" element={<InsuranceDetail />} /> */}
                {/* 공제 -의료비*/}
                <Route path="/deductions/medicalExpenses" element={<MedicalExpenses />} />
                {/* <Route path="/deductions/medicalExpenses/detail" element={<MedicalDetail />} /> */}
                {/* 공제 -교육비*/}
                <Route path="/deductions/educationExpenses" element={<EducationExpenses />} />
                {/* <Route path="/deductions/educationExpenses/detail" element={<EducationDetail />} /> */}
                {/* 공제 -기부금*/}
                <Route path="/deductions/donations" element={<Donations />} />
                <Route path="/deductions/donations/detail" element={<DonationsDetail />} />
                {/* 공제 -신용카드*/}
                <Route path="/deductions/creditCards" element={<CreditCards />} />
                {/* 공제 -주택자금*/}
                <Route path="/deductions/housingFunds" element={<HousingFunds />} />
                {/* 공제 -기타*/}
                <Route path="/deductions/otherDeductions" element={<OtherDeductions />} />
                {/* 증빙서류*/}
                <Route path="/evidenceDocuments" element={<EvidenceDocuments />} />
                <Route path="/evidenceDocuments/noHeader" element={<EvidenceDocuments />} />
                {/* 결과조회*/}
                <Route path="/resultQuery" element={<ResultQuery />} />
                <Route path="/chat" element={<Twc />} />
                <Route path="/AuthComplete" element={<AuthComplete />} />
                {/* ai 연말정산 세법 도우미 */}
                <Route path="/aiAsst" element={<AiAssistantDialog />} />
                
                <Route path="/taxChangeAlert" element={<TaxChangeAlert />} /> {/* 세액변경 알림 */}
              </Route>
              {/*약관 */}

              <Route path="/terms" element={<Terms />} />
              <Route path="/login" element={<Login />} />
              <Route path="/birthLogin" element={<BirthLogin />} />
              <Route path="/ssoLogin" element={<SSOLogin />} />
              <Route path="/smsVerify" element={<BirthVerification />} />
              <Route path="/findPassword" element={<FindPassword />} />
              <Route path="/sp" element={<Gate />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};

export default MainRoute;
